import {useTranslation} from "react-i18next";
import "moment-timezone";
import Form from "react-bootstrap/Form";
import {Link} from "react-router-dom";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const labelsDefault = [
    {label: "common.plugin", required: true},
    {label: "common.actions", required: true},
];

const TablePlugins = ({items, orderingRef, onClickRow, onChangeActive}) => {
    const {t: _Tt} = useTranslation("tables");
    const callbacksNames = {
        mqttin: _Tt("plugins.mqttin"),
        inventory: _Tt("plugins.inventory"),
    };
    const callbacksTemplates = (call, token) => {
        switch (call) {
            case "mqttin":
                return <div>{_Tt("plugins.mqttin")}</div>;
            case "inventory":
                return (
                    <>
                        <div>{_Tt("plugins.inventory")}</div>
                        <div className="row mt-3">
                            <div className="col-2">
                                <Link
                                    to={"/administration/plugins/import/" + token + "/"}
                                    className="btn btn-outline-primary btn-sm">
                                    Importar
                                </Link>
                            </div>
                            <div className="col-2">
                                <Link
                                    to={"/administration/plugins/list/" + token + "/"}
                                    className="btn btn-outline-primary btn-sm">
                                    Listados
                                </Link>
                            </div>
                            <div className="col-2">
                                <Link
                                    to={"/administration/plugins/export/" + token + "/"}
                                    className="btn btn-outline-primary btn-sm">
                                    Exportar
                                </Link>
                            </div>
                        </div>
                    </>
                );

            default:
                return "-";
        }
    };

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th key="-1" style={{width: "35px"}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index}>
                        <td style={{verticalAlign: "middle"}}>
                            <input
                                type="checkbox"
                                name="callback"
                                data-idx={index}
                                value={item.key}
                                onChange={onClickRow}
                            />
                        </td>
                        <td style={{textAlign: "center", verticalAlign: "middle"}}>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id={"active-" + index}
                                checked={item.active}
                                data-idx={index}
                                onChange={onChangeActive}
                            />
                        </td>
                        <td>
                            <div className="card-table">
                                <img
                                    src={`/media/plugins/${item.slug}/image.png`}
                                    style={{width: "200px"}}
                                    alt="logo callback"
                                />
                                <h3 className="mt-3">{item.name}</h3>
                                <p>{item.description}</p>
                            </div>
                        </td>
                        <td style={{verticalAlign: "middle"}}>
                            <ul>
                                <li>KEY: {item.key}</li>
                                {item.callbacks.map((call, idx) => (
                                    <li key={idx}>
                                        {callbacksTemplates(call, item.token)}
                                    </li>
                                ))}
                            </ul>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TablePlugins;
